// core.reducer.ts
import { CoreState, coreReducer } from './core.reducer';
import { FeedState, feedReducer } from './feed.reducer';
import { FormState, formReducer } from './form.reducer';
import { HomeState, homeReducer } from './home.reducer';
import {
  MainMenuState,
  mainMenuReducer,
} from './main-menu.reducer';
import { ObjectState, objectReducer } from './object.reducer';
import { PostState, postReducer } from './post.reducer';
import {
  SelectedObjectsState,
  selectedObjectsReducer,
} from './selected.reducer';
// auth.reducer.ts
import { UserState, userReducer } from './auth.reducer';
import { WidgetState, widgetReducer } from './widget.reducer';
import {
  WorkspaceState,
  workspaceReducer,
} from './workspace.reducer';

import { ActionReducerMap } from '@ngrx/store';
import {
  principalReducer,
  PrincipalState,
} from './principals.reducer';

export interface AppState {
  user: UserState;
  core: CoreState;
  feed: FeedState;
  widget: WidgetState;
  object: ObjectState;
  post: PostState;
  workspace: WorkspaceState;
  home: HomeState;
  selected: SelectedObjectsState;
  mainMenu: MainMenuState;
  form: FormState;
  principals: PrincipalState;
}

export const reducers: ActionReducerMap<AppState> = {
  user: userReducer,
  core: coreReducer,
  feed: feedReducer,
  widget: widgetReducer,
  object: objectReducer,
  post: postReducer,
  workspace: workspaceReducer,
  home: homeReducer,
  selected: selectedObjectsReducer,
  mainMenu: mainMenuReducer,
  form: formReducer,
  principals: principalReducer,
};
